/*
 * File: components/SponsorInfo.tsx
 * Author: Hannah Murphy
 * Date: 2024
 * Description: Arrays of all sponsors and their information for 2024.
 *              These arrays are imported and used in pages/sponsors.tsx
 *
 * Copyright (c) 2024 WESMO. All rights reserved.
 * This code is part of the  WESMO Data Acquisition and Visualisation Project.
 */

import nhp from "../images/sponsors/nhp.png";
import hall_machinery from "../images/sponsors/hall_machinery.png";
import industrial_tube from "../images/sponsors/industrial_tube.jpeg";
import initiom from "../images/sponsors/Initiom.png";
import nz_van_lines from "../images/sponsors/nz_van_lines.png";
import jlc_pcb from "../images/sponsors/jlc_pcb.jpeg";
import island_bay from "../images/sponsors/IBC_logo_HR.jpg";
import rml from "../images/sponsors/rml.jpeg";
import enepaq from "../images/sponsors/enepaq.svg";
import adhesive from "../images/sponsors/adhesive_tech.png";
import gurit from "../images/sponsors/gurit.jpg";
import kilwell from "../images/sponsors/kilwell.jpeg";
import performance from "../images/sponsors/performance_boats.png";
import waikato_bearings from "../images/sponsors/waikato_bearings.jpeg";
import flight_structures from "../images/sponsors/flight_structures.png";
import lg_panel_paint from "../images/sponsors/lg_panel_paint.png";
import ansys from "../images/sponsors/ansys.jpg";
import marshall_profiling from "../images/sponsors/marshall_profiling.png";
import ndl from "../images/sponsors/ndl.jpg";
import meg from "../images/sponsors/meg.webp";
import apl from "../images/sponsors/apl.png";
import wsu from "../images/sponsors/wsu.png";
import stafford from "../images/sponsors/stafford.png";
import coroflex from "../images/sponsors/coroflex.png";
import vulcan from "../images/sponsors/vulcan.png";
import polymaker from "../images/sponsors/polymaker.png";

export const bronze = [
  { title: "JLC PCB", img: jlc_pcb, link: "https://jlcpcb.com/" },
  { title: "RML", img: rml, link: "https://www.rmlnz.com/" },
];

export const silver = [
  {
    title: "NDL Engineering",
    img: ndl,
    link: "https://www.ndlengineering.co.nz/",
  },
  {
    title: "Gurit",
    img: gurit,
    link: "https://www.gurit.com/",
  },
  {
    title: "Vulcan Aluminium",
    img: vulcan,
    link: "https://vulcan.co/product/aluminium/",
  },
];

export const gold = [
  {
    title: "Island Bay Services Club",
    img: island_bay,
    link: "https://www.islandbaytsc.org.nz/",
  },
  {
    title: "NZ Van Lines",
    img: nz_van_lines,
    link: "https://nzvanlines.co.nz/",
  },
  {
    title: "Adhesive Tech",
    img: adhesive,
    link: "https://adhesivetechnologies.co.nz/",
  },
  {
    title: "KillWell Fibrelab",
    img: kilwell,
    link: "https://www.kilwellfibrelab.co.nz/",
  },
  {
    title: "Marshall Profiling",
    img: marshall_profiling,
    link: "https://marshallprofiling.co.nz/",
  },
  {
    title: "Coroflex",
    img: coroflex,
    link: "https://www.coroflex-cable.com/en/",
  },
  {
    title: "Polymaker",
    img: polymaker,
    link: "https://polymaker.com/",
  },
];

export const platinum = [
  {
    title: "NHP",
    img: nhp,
    link: "https://www.nhpnz.co.nz/",
  },
  {
    title: "Enepaq",
    img: enepaq,
    link: "https://enepaq.com/",
  },
  {
    title: "Industrial Tube",
    img: industrial_tube,
    link: "https://www.industrialtube.co.nz/",
  },
  {
    title: "Initiom",
    img: initiom,
    link: "https://www.initiom.co.nz/",
  },
  {
    title: "Hall Machinery Ltd",
    img: hall_machinery,
    link: "https://www.hallmach.co.nz/",
  },
  {
    title: "Performance Boat Building",
    img: performance,
    link: "https://www.facebook.com/p/Performance-Boatbuilding-100072364330870/",
  },
  {
    title: "Waikato Bearings",
    img: waikato_bearings,
    link: "https://www.waikatobearings.co.nz/",
  },
  {
    title: "Flight Structures",
    img: flight_structures,
    link: "https://www.flightstructures.co.nz/",
  },
  {
    title: "LG Panel and Paint",
    img: lg_panel_paint,
    link: "https://www.lgpanelandpaint.co.nz/",
  },
  {
    title: "Ansys",
    img: ansys,
    link: "https://www.ansys.com/",
  },
  {
    title: "MEG",
    img: meg,
    link: "https://www.mechanical-engineering-group.org.nz/",
  },
  {
    title: "APL Window Solutions",
    img: apl,
    link: "https://www.aplnz.co.nz/",
  },
  {
    title: "Stafford",
    img: stafford,
    link: "https://staffordrecruit.co.nz/",
  },
  {
    title: "Waikato Students Union",
    img: wsu,
    link: "https://wsu.org.nz/",
  },
];
